var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBulbRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.87,
    height: 80.87,
    viewBox: "0 0 80.87 80.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BULB_WRONG",
    "data-name": "BULB WRONG",
    transform: "translate(17.57 18.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NEUTRE",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M50.728,27.86a22.814,22.814,0,0,1-8.72,17.964,10.965,10.965,0,0,0-4.181,6.565.294.294,0,0,0-.163-.033h-19.6a.556.556,0,0,0-.229.033,9.938,9.938,0,0,0-3.723-6.271A22.864,22.864,0,1,1,50.728,27.86Z",
    transform: "translate(-4.999 -5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M28.919,19.533a9.658,9.658,0,0,0-.163,1.7v7.251A5.743,5.743,0,0,1,23.04,34.2H14.874c-2.744,0-5.716-2.09-5.716-6.663V21.754a10.053,10.053,0,0,0-.229-2.221.556.556,0,0,1,.229-.033h19.6a.294.294,0,0,1,.163.033Z",
    transform: "translate(3.91 27.855)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M26.147,24.4H11.45a2.45,2.45,0,0,1,0-4.9h14.7a2.45,2.45,0,0,1,0,4.9Z",
    transform: "translate(4.069 27.855)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M31.942,67.054H23.777c-2.753,0-5.716-2.09-5.716-6.676V54.616a10.588,10.588,0,0,0-3.949-8.508,22.862,22.862,0,1,1,27.873-.291,10.642,10.642,0,0,0-4.328,8.26v7.261A5.722,5.722,0,0,1,31.942,67.054ZM27.814,9.9a18.972,18.972,0,0,0-3.861.4,17.953,17.953,0,0,0-6.9,31.887,15.508,15.508,0,0,1,5.9,12.424v5.761c0,.3.039,1.777.817,1.777h8.165a.817.817,0,0,0,.817-.817V54.078a15.506,15.506,0,0,1,6.2-12.114A17.944,17.944,0,0,0,27.814,9.9Z",
    transform: "translate(-4.993 -5.001)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WRONG",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755-2",
    "data-name": "Path 1755",
    d: "M50.728,27.86a22.814,22.814,0,0,1-8.72,17.964,10.965,10.965,0,0,0-4.181,6.565.294.294,0,0,0-.163-.033h-19.6a.556.556,0,0,0-.229.033,9.938,9.938,0,0,0-3.723-6.271A22.864,22.864,0,1,1,50.728,27.86Z",
    transform: "translate(-4.999 -5)",
    fill: "#f07c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2",
    "data-name": "Path 1756",
    d: "M28.919,19.533a9.658,9.658,0,0,0-.163,1.7v7.251A5.743,5.743,0,0,1,23.04,34.2H14.874c-2.744,0-5.716-2.09-5.716-6.663V21.754a10.053,10.053,0,0,0-.229-2.221.556.556,0,0,1,.229-.033h19.6a.294.294,0,0,1,.163.033Z",
    transform: "translate(3.91 27.855)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757-2",
    "data-name": "Path 1757",
    d: "M26.147,24.4H11.45a2.45,2.45,0,0,1,0-4.9h14.7a2.45,2.45,0,0,1,0,4.9Z",
    transform: "translate(4.069 27.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M25.381,23.83a2.45,2.45,0,0,1-2.45-2.45A8.989,8.989,0,0,0,13.95,12.4a2.45,2.45,0,1,1,0-4.9A13.9,13.9,0,0,1,27.83,21.381,2.45,2.45,0,0,1,25.381,23.83Z",
    transform: "translate(9.734 0.662)",
    fill: "#ffaa9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766-2",
    "data-name": "Path 1766",
    d: "M31.942,67.054H23.777c-2.753,0-5.716-2.09-5.716-6.676V54.616a10.588,10.588,0,0,0-3.949-8.508,22.862,22.862,0,1,1,27.873-.291,10.642,10.642,0,0,0-4.328,8.26v7.261A5.722,5.722,0,0,1,31.942,67.054ZM27.814,9.9a18.972,18.972,0,0,0-3.861.4,17.953,17.953,0,0,0-6.9,31.887,15.508,15.508,0,0,1,5.9,12.424v5.761c0,.3.039,1.777.817,1.777h8.165a.817.817,0,0,0,.817-.817V54.078a15.506,15.506,0,0,1,6.2-12.114A17.944,17.944,0,0,0,27.814,9.9Z",
    transform: "translate(-4.993 -5.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1413",
    "data-name": "Rectangle 1413",
    transform: "translate(-17.57 -18.816)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.87,
    height: 80.87,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79.87,
    height: 79.87,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbRed);
export default __webpack_public_path__ + "static/media/light-bulb-red.f666b3a2.svg";
export { ForwardRef as ReactComponent };